import React from 'react';
import { Box, ButtonSwitchGroup } from '@ublend-npm/aulaui-core';

export type CommonRoomTab = 'feed' | 'pinned';

interface CommonRoomTabsProps {
  activeTab: CommonRoomTab;
  pinnedCount?: number;
  onTabChange: (tab: CommonRoomTab) => void;
}

const tabs: CommonRoomTab[] = ['feed', 'pinned'];

const CommonRoomTabs = ({
  activeTab,
  pinnedCount = 0,
  onTabChange,
}: CommonRoomTabsProps) => {
  const activeIndex = Math.max(tabs.indexOf(activeTab), 0);

  const handleSelect = (index: number) => {
    const selectedTab = tabs[index];

    if (selectedTab && selectedTab !== activeTab) {
      onTabChange(selectedTab);
    }
  };

  return (
    <Box
      role="group"
      aria-label="Common Room post view"
      sx={{
        width: 184,
        height: 40,
        '& > div': {
          height: '100%',
          boxSizing: 'border-box',
        },
        '& > div > button': {
          height: 32,
          minHeight: 32,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0,
          whiteSpace: 'nowrap',
        },
      }}
    >
      <ButtonSwitchGroup
        size="small"
        options={['Feed', `Pinned (${pinnedCount})`]}
        activeIndex={activeIndex}
        onSelect={handleSelect}
      />
    </Box>
  );
};

export default CommonRoomTabs;
